import { config } from 'src/config'
import { getMetafield } from 'src/functions/util/getMetafield'

import type { Collection, Maybe, Metafield, Product } from 'src/data/graphql-generated'

export const getProductBreadcrumbs = (
  productCollections: Collection[],
  productMetafields: Maybe<Metafield>[],
  productType: Product['productType'],
) => {
  const topLevelCollectionId =
    productType === 'coffee'
      ? // Coffee
        config.mainCoffeeCollectionId
      : // Gear
        config.mainGearCollectionId

  const mainCollectionReference = getMetafield(productMetafields, 'seo', 'breadcrumb_collection')
  const mainCollection = productCollections.find((collection) => collection.id === mainCollectionReference)
  const topLevelCollection = productCollections.find((collection) => collection.id === topLevelCollectionId)

  const breadcrumbs = [topLevelCollection, mainCollection].filter((p) => p)

  return breadcrumbs
}
